export default {
    'sales-contracts': 'Sales Contracts',
    'the-sales-contract': 'the sales contract?',
    'add-a-sales-contract': 'Add a sales contract',

    'sales-contract': 'sales contract',
}